import React from 'react';
import {Text, HStack} from 'native-base';
import {message} from '../../utils/messages';
import {ResponsiveValue} from 'native-base/lib/typescript/components/types';

interface Props {
  caption: string;
  icon?: JSX.Element;
  mt?: string;
  color?: string;
  fontWeight?: ResponsiveValue<
    | number
    | 'bold'
    | (string & {})
    | 'black'
    | 'light'
    | 'normal'
    | 'hairline'
    | 'thin'
    | 'medium'
    | 'semibold'
    | 'extrabold'
    | 'extraBlack'
  >;
}

const Label = (props: Props) => {
  const {caption, icon, mt, color, fontWeight} = props;
  const Icon = () => <>{icon}</>;
  return (
    <HStack alignItems={'center'} mt={mt}>
      <Icon />
      <Text color={color ?? 'gray.400'} fontWeight={fontWeight ?? 'normal'}>
        {message(caption)}
      </Text>
    </HStack>
  );
};

export default Label;
